exports.default = {
  radii: {
    "0": "0px",
    "1": "3px",
    "2": "4px",
    "3": "6px",
    "4": "8px",
    "5": "9999999px",
  },
};
